<div class="wrapper">
  <div *ngFor="let v of parkings">
    <div class="flex-container">
      <div>
        <label>{{ v.variableName | translate }} ({{ v.unit }})</label>
      </div>
      <div>
        <input
          type="number"
          min="0"
          [(ngModel)]="v.value"
          [disabled]="!editable"
          pInputText
        />
      </div>
    </div>
  </div>
  <div class="center">
    <div>
      <span>{{ 'LAST_UPDATED' | translate }}: </span>
      <!-- <span> {{ parkings[0].modificationDate | date: DATE_FORMAT }}</span> --> 
      <span> {{ getModificationDate( parkings[0] ) | date: DATE_FORMAT }}</span>
    </div>
  </div>
</div>
<ng-content></ng-content>
